import { useSelector } from 'react-redux';
import { RetirementGoalData } from './Retirement.meta';
import { ALREADY_RETIRED } from '../../Goals.meta';
import { selectCurrentClient } from '../../../../CommonSelectors/CommonAreaSelector';

export const getRetirementAgeOptions = (ageOptions: number[] | null, yob: number | null) => {
  if (!ageOptions) {
    return [];
  }

  return [
    { label: ALREADY_RETIRED, value: ALREADY_RETIRED },
    ...ageOptions.map(age => ({
      label: age.toString(),
      value: age,
      rightLabel: yob ? yob + age : undefined,
    })),
  ];
};

interface Params {
  goalData: RetirementGoalData;
}

export const useRetirement = ({ goalData }: Params) => {
  const { Dob: primaryDob, PartnerDob: spouseDob } = useSelector(selectCurrentClient);

  const primaryYob = primaryDob ? new Date(primaryDob).getFullYear() : null;
  const spouseYob = spouseDob ? new Date(spouseDob).getFullYear() : null;

  return {
    ...goalData,
    principalRetirementAgeOptions: getRetirementAgeOptions(
      goalData.principalRetirementAgeOptions,
      primaryYob,
    ),
    spouseRetirementAgeOptions: getRetirementAgeOptions(
      goalData.spouseRetirementAgeOptions,
      spouseYob,
    ),
  };
};
